import { TableHeader, TableHeaderCell } from '@hivewatch/dark'

import { GuardToursColumnIProps } from './Columns'

export const GuardToursTableHeader = ({
  columns,
}: {
  columns: GuardToursColumnIProps[]
}) => {
  return (
    <TableHeader>
      {columns.map((col) => (
        <TableHeaderCell column={col.sortColumn} key={col.key} {...col.style}>
          {col.header}
        </TableHeaderCell>
      ))}
    </TableHeader>
  )
}
